<template>
    <div v-if="showElement" class="d-inline-block mt-lg-8 p-4 movie-single-header-today">
        <i class="fas fa-video font-size-huge"></i>

        <h2 class="mt-3 color-brand--secondary">
            Vandaag
        </h2>

        <p class="mt-4 font-size-h4 font-weight-semibold">
            {{ startTime }}<br>
            {{ cinemaName }}
        </p>

        <a class="btn btn-secondary btn-more-line-height text-uppercase text-center font-weight-extrabold scroll-link" href="#" data-scroll-to="#filmagenda">
            Bekijk alle filmtijden
        </a>
    </div>
</template>

<script>
    export default {
        props: {
            movieId: {
                type: Number,
                required: true,
            },
        },
        data() {
            return {
                showElement: false,
                startTime: null,
                cinemaName: null,
            };
        },
        mounted() {
            VueEvents.$on('location:triggered', this.getPerformanceToday);
            if(MrMovie.geolocation.getLocationFromSession()) {
                this.getPerformanceToday();
            }

        },
        methods: {
            getPerformanceToday() {
                MrMovie.geolocation.getCurrentLocation()
                    .then(location => {
                        const callArgs = {
                            movieId: this.movieId,
                            latitude: location.latitude,
                            longitude: location.longitude,
                        };

                        $.getJSON('/ajax/nearest-movie-performances', callArgs)
                            .then(cinemas => {
                                // The day ends at 4:00 (the next day)
                                const endOfToday = new Date();
                                endOfToday.setDate(endOfToday.getDate() + 1);
                                endOfToday.setHours(4);
                                endOfToday.setMinutes(0);
                                endOfToday.setSeconds(0);

                                for (let i=-1; ++i<cinemas.length;) {
                                    const cinema = cinemas[i];

                                    // Cinema needs to have performances
                                    if (! cinema.performances || (cinema.performances && ! cinema.performances.length)) {
                                        return null;
                                    }

                                    // See if there is a performance today
                                    for (let j=-1; ++j<cinema.performances.length;) {
                                        const performance = cinema.performances[j];
                                        const performanceStart = new Date(performance.start);

                                        // See if the performance is on the current day
                                        if (performanceStart < endOfToday) {
                                            // Show the element with the performance info, and stop looping
                                            this.startTime = performance.startTime;
                                            this.cinemaName = cinema.cinema.name;
                                            this.showElement = true;
                                            break;
                                        }
                                    };

                                    // Stop looping if a performance was found
                                    if (this.cinemaName !== null) {
                                        break;
                                    }
                                };
                            })
                    });
            }
        }
    };
</script>



// WEBPACK FOOTER //
// resources/js/components/movies/single/MoviePerformanceToday.vue